import type { ClientOrganizationFact } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo, type FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { Divider, Text } from 'react-native-paper';

import { InfoIcon } from '@/assets';
import { Row } from '@/shared/components/layout/Row';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    row: {
      minHeight: 56,
      alignItems: 'center',
      gap: 16,
      paddingVertical: 8,
      paddingHorizontal: 16
    },
    factText: {
      flex: 1,
      fontSize: 16,
      lineHeight: 24,
      letterSpacing: 0.5,
      color: theme.colors.onSurface
    },
    divider: { backgroundColor: theme.colors.outlineVariant }
  });

export const TerritorialAuthorityFactsList: FC<{
  facts: ClientOrganizationFact[];
}> = ({ facts }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  if (facts.length === 0) {
    return <></>;
  }

  return (
    <View>
      {facts.map((fact) => (
        <View key={fact.name}>
          <Row style={styles.row}>
            <InfoIcon
              fill={theme.colors.onSurfaceVariant}
              width={24}
              height={24}
            />
            <Text style={styles.factText} numberOfLines={1}>
              {fact.name}: {fact.value}
            </Text>
          </Row>
          <Divider style={styles.divider} />
        </View>
      ))}
    </View>
  );
};
